import { getLocalizedSorting } from '../translations/default'

export const ProductFilter = {
  dangerousGoods: 'filter[dangerousGoodsClass.equals]',
  hazardousGoods: 'filter[salesGroupProducts.hazardous.equals]',
  myProducts: 'filter[myProducts.equals]',
  packageType: 'filter[packaging.type.equals]',
  pricePointExists: 'filter[pricePoints.exists]',
  productId: 'filter[id.in]',
  productName: 'filter[name.icontains]',
  productNumber: 'filter[number.icontains]',
  searchQuery: 'search[query]',
  shipToLocationId: 'shipToLocationId',
  sort: 'sort',
  yourProductNumber: 'filter[customerContextProducts.number.icontains]',
}

export const productFilterTranslationMap = {
  sort: getLocalizedSorting,
}

export const productFilterDefaults = {
  page: '1',
  sort: 'name',
}

export type ProductFilters = typeof ProductFilter
export type ProductFilterKey = keyof ProductFilters
export type ProductFilterFnKey = keyof typeof productFilterTranslationMap
